<div class="m-auto mt-2 w-full md:w-4/5">
  <yr-subscriptions></yr-subscriptions>
</div>
